export default function GeneralFeedback({ ratings, feedback }) {
  console.log(ratings);
  let avgStars = (ratings.reduce((a, b) => a + b, 0) / ratings.length) * 2;

  function formatLLMOutput(text) {
    // Split by double line breaks for paragraphs
    const paragraphs = text.split("\n\n");

    return paragraphs.map((para, i) => {
      // Handle bullet points
      if (para.trim().startsWith("•")) {
        const bullets = para.split("\n").map((line, index) => {
          const item = line.replace(/^•\s*/, "");
          return (
            <li key={index} class="gen-li">
              {item}
            </li>
          );
        });
        return <ul key={i}>{bullets}</ul>;
      }

      // Regular paragraph
      return (
        <p key={i} class="gen-p">
          {para}
        </p>
      );
    });
  }

  return (
    <div class="general-feedback">
      <h2>{`${avgStars * 10}%`}</h2>
      <p>{formatLLMOutput(feedback)}</p>
    </div>
  );
}
